import * as paths from './paths';

export default {
  [paths.OPEN_BETS]: 'Open bets',
  [paths.SETTLED_BETS]: 'Settled bets',
  [paths.SETTINGS]: 'Account',
  [paths.LOST_CARD]: 'Account',
  [paths.CHANGE_NUMBER]: 'Account',
  [paths.MARKETING_PREFERENCES]: 'Account',
  [paths.ADD_BETSLIP]: 'Add bet',
  [paths.SUPPORT]: 'Support',
  [paths.LINK_SUCCESS]: 'Account',
  [paths.OMNI_SET_PIN]: 'Account',
  [paths.OMNI_WITHDRAW]: 'Withdraw',
  [paths.OMNI_TRANSFER]: 'Transfer',
  [paths.COOKIE]: 'Policies',
  [paths.TERMS]: 'Policies',
  [paths.RESPONSIBLE_GAMBLING]: 'Responsible gambling',
  [paths.NOT_FOUND]: 'Error 404',
  [paths.OFFERS]: ['Your', 'Offers'],
  [paths.BETTING_BUDDY]: 'Betting Buddy',
  [paths.LIVE_SCORES]: ['Football', 'Scores'],
  [paths.LINK_ACCOUNT]: 'Link Account',
  [paths.REGISTER]: 'Register'
};
